/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import type { Calendar } from './Calendar';
/**
 * 
 * @export
 * @interface Warmup
 */
export interface Warmup {
    /**
     * 
     * @type {Date}
     * @memberof Warmup
     */
    date?: Date;
    /**
     * 
     * @type {number}
     * @memberof Warmup
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof Warmup
     */
    timeSpent?: number | null;
    /**
     * 
     * @type {Calendar}
     * @memberof Warmup
     */
    dateNavigation?: Calendar;
    /**
     * 
     * @type {User}
     * @memberof Warmup
     */
    user?: User;
}

/**
 * Check if a given object implements the Warmup interface.
 */
export function instanceOfWarmup(value: object): value is Warmup {
    return true;
}

export function WarmupFromJSON(json: any): Warmup {
    return WarmupFromJSONTyped(json, false);
}

export function WarmupFromJSONTyped(json: any, ignoreDiscriminator: boolean): Warmup {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'userId': json['userId'] == null ? undefined : json['userId'],
        'timeSpent': json['timeSpent'] == null ? undefined : json['timeSpent'],
        'dateNavigation': json['dateNavigation'] == null ? undefined : (require('./Calendar') as typeof import('./Calendar')).CalendarFromJSON(json['dateNavigation']),
        'user': json['user'] == null ? undefined : (require('./User') as typeof import('./User')).UserFromJSON(json['user']),
    };
}

export function WarmupToJSON(json: any): Warmup {
    return WarmupToJSONTyped(json, false);
}

export function WarmupToJSONTyped(value?: Warmup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'userId': value['userId'],
        'timeSpent': value['timeSpent'],
        'dateNavigation': (require('./Calendar') as typeof import('./Calendar')).CalendarToJSON(value['dateNavigation']),
        'user': (require('./User') as typeof import('./User')).UserToJSON(value['user']),
    };
}

